var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "search-replace-dialog" }, [
    _c(
      "div",
      { staticClass: "switch-mode", on: { click: _vm.toggleEnabledReplace } },
      [
        _c("ChevronRightIcon", {
          staticClass: "material-design-icons",
          class: { rotateRight: _vm.enabledReplace },
          attrs: { fillColor: "#474a4d" },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "content" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          ref: "inputSearch",
          staticClass: "input-search",
          attrs: {
            id: "inputSearch",
            type: "text",
            placeholder: _vm.$t("searchReplaceDialog.searchPlaceholder"),
          },
          domProps: { value: _vm.searchText },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onEnterKey.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.searchText = $event.target.value
            },
          },
        }),
        _c("div", { staticClass: "index-count" }, [
          _vm._v(_vm._s(_vm.indexCount)),
        ]),
        _c(
          "div",
          { staticClass: "icons-wrapper" },
          [
            _c("ArrowUpIcon", {
              staticClass: "material-design-icons icon",
              class: { disabled: _vm.totalCount === 0 },
              attrs: { fillColor: "#474a4d" },
              on: { click: _vm.onClickPrev },
            }),
            _c("ArrowDownIcon", {
              staticClass: "material-design-icons icon",
              class: { disabled: _vm.totalCount === 0 },
              attrs: { fillColor: "#474a4d" },
              on: { click: _vm.onClickNext },
            }),
          ],
          1
        ),
      ]),
      _vm.enabledReplace
        ? _c("div", { staticClass: "content" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.replaceText,
                  expression: "replaceText",
                },
              ],
              staticClass: "input-replace",
              attrs: {
                type: "text",
                placeholder: _vm.$t("searchReplaceDialog.replacePlaceholder"),
              },
              domProps: { value: _vm.replaceText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.replaceText = $event.target.value
                },
              },
            }),
            _c("div", { staticClass: "icons-wrapper" }, [
              _c("img", {
                staticClass: "single",
                attrs: {
                  src: require("@/assets/img/icon/replace_single.png"),
                  alt: "replace single",
                },
                on: { click: _vm.onClickReplaceSingle },
              }),
              _c("img", {
                staticClass: "all",
                attrs: {
                  src: require("@/assets/img/icon/replace_all.png"),
                  alt: "replace all",
                },
                on: { click: _vm.onClickReplaceAll },
              }),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }